__turbopack_context__.v({
  "default": "Loader-module__axtKsa__default",
  "primary": "Loader-module__axtKsa__primary",
  "secondary": "Loader-module__axtKsa__secondary",
});
